import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/sass/style.scss'
const firebase = require('./firebase.js');

Vue.config.productionTip = false

Vue.use(require('vue-moment'));
Vue.config.performance = true;

let app
firebase.auth.onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});
